// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ExemptionPropertyChangeDisplayType {
  Unkwnown = "UNKWNOWN",
  SingleLicensePlateChange = "SINGLE_LICENSE_PLATE_CHANGE",
  SingleCountryChange = "SINGLE_COUNTRY_CHANGE",
  BulkLicensePlateChange = "BULK_LICENSE_PLATE_CHANGE",
  BulkCountryChange = "BULK_COUNTRY_CHANGE",
  ValidSinceChange = "VALID_SINCE_CHANGE",
  ValidUntilChange = "VALID_UNTIL_CHANGE",
  CreationRecordIdChange = "CREATION_RECORD_ID_CHANGE",
  CancellationRecordIdChange = "CANCELLATION_RECORD_ID_CHANGE",
  VehicleRegistrationChangeRecordIdChange = "VEHICLE_REGISTRATION_CHANGE_RECORD_ID_CHANGE",
  CancellationMethodChange = "CANCELLATION_METHOD_CHANGE",
  CancellationReasonChange = "CANCELLATION_REASON_CHANGE",
  IsDeletedChange = "IS_DELETED_CHANGE",
  VehicleRegisterVehicleIdChange = "VEHICLE_REGISTER_VEHICLE_ID_CHANGE",
  VehicleRegisterSynchronizationStatusChange = "VEHICLE_REGISTER_SYNCHRONIZATION_STATUS_CHANGE",
  VehicleRegisterVehiclePropertiesChange = "VEHICLE_REGISTER_VEHICLE_PROPERTIES_CHANGE",
  ExemptionReasonIdChange = "EXEMPTION_REASON_ID_CHANGE",
  Inapplicable = "INAPPLICABLE",
  Unprocessed = "UNPROCESSED",
  UnprocessedDueToDuplication = "UNPROCESSED_DUE_TO_DUPLICATION",
  VehicleNotFound = "VEHICLE_NOT_FOUND",
  Processed = "PROCESSED",
  Notification = "NOTIFICATION",
  VehicleRegisterSynchronization = "VEHICLE_REGISTER_SYNCHRONIZATION",
}
export default ExemptionPropertyChangeDisplayType;
